import Progress from './Progress';
import ProgressLine from './ProgressLine';

// export types
export type { ProgressLineProps as ProgressProps } from './ProgressLine';
export type { ProgressSection } from './types';

// export components
export { Progress, ProgressLine };
export default Progress;
